import { Component, OnInit, ViewChild,  OnDestroy } from '@angular/core';
import { NgForm } from '@angular/forms';
import { DatePipe } from '@angular/common';
import { INgxMyDpOptions } from 'ngx-mydatepicker';
import { AppConstants, SERVER, LOGON_INFO, CODE, CARGO_LIST_TYPE, CARGO_STATUS, IMPORTANCE_TYPE, COMP_TYPE, SHARE_FLAG, DATEPICKER, CAR_STATUS } from '../app.constants';
import { GooglemapService, LocationInfo } from '../common/googlemap.service';
import { CommonService, Code, Zipcode } from '../app.service';
import { MessageService } from '../common/message.service';
import { Cargo, CargoService } from './cargo.service';
import { Car, CarService } from '../member-kanri/car.service';
import { Company, CompanyService } from '../member-kanri/company.service';
import { UserService } from '../member-kanri/user.service';
import $ from 'jquery';

declare let google: any;


@Component({
    selector: 'transport-cargo',
    templateUrl: 'transport-cargo.component.html',
    providers: [CargoService, GooglemapService, CompanyService, CarService, UserService]
})
export class TransportCargoComponent implements OnInit, OnDestroy {

    CARGO_LIST_TYPE: any = CARGO_LIST_TYPE;
    IMPORTANCE_TYPE: any = IMPORTANCE_TYPE;
    CARGO_STATUS: any = CARGO_STATUS;
    CAR_STATUS: any = CAR_STATUS;

    @ViewChild(NgForm) f: NgForm;

    //ログイン会社情報
    comp_id: string = LOGON_INFO.COMP_ID;
    parent_comp_id: string = LOGON_INFO.PARENT_COMP_ID;

    timeDivideCodeList: Code[];
    loadMethodCodeList: Code[];
    carAbilityCodeList: Code[];
    chargeUnitCodeList: Code[];
    todohukenList: any[];

    carList: Car[];
    selCar: Car;

    branchList: Company[] = [];
    partnerList: Company[] = [];

    cargoList_order: Cargo[];
    cargoList_ship: Cargo[];
    currentCargo: Cargo;
    selectCargo: string;
    selectCargoClient: string;
    selectCargoTrans: string;

    //pagination
    perPage_order: number = AppConstants.PAGE_SIZE_LARGE;
    perPage_ship: number = AppConstants.PAGE_SIZE_LARGE;
    currPage_order: number;
    totalCount_order: number;
    currPage_ship: number;
    totalCount_ship: number;

    //スケジュール表示切り替え用
    startDate: Date = new Date();

    //地図表示用
    isMapShow: boolean = true;
    origin: any;
    destination: any;

    search_div: string;
    address_search_list: LocationInfo[];
    search_keyword: string = "";

    myDatePickerOptions: INgxMyDpOptions = DATEPICKER.myDatePickerOptions;
    myDatePickerOptions_noDisableUntil: INgxMyDpOptions = DATEPICKER.myDatePickerOptions_noDisableUntil;

    transSocket: any;

    search_load_todohuken: string = "";
    search_ship_load_todohuken: string = "";
    search_load_date_start: any;
    search_load_date_end: any;
    search_ship_load_date_start: any;
    search_ship_load_date_end: any;


    constructor(
        private commonService: CommonService,
        private mapService: GooglemapService,
        private cargoService: CargoService,
        private msgService: MessageService,
        private carService: CarService,
        private datePipe: DatePipe,
        private companyService: CompanyService,
        private userService: UserService
    ) {  }


    async ngOnInit() {
        //$('#cargo_table_title').width($(window).width() - $('#cargo_form').width() - 60);

        this.timeDivideCodeList = CODE.TIME_DIVIDE;
        this.loadMethodCodeList = CODE.LOAD_METHOD;
        this.carAbilityCodeList = CODE.CAR_ABILITY;
        this.chargeUnitCodeList = CODE.CHARGE_UNIT;
        this.todohukenList = CODE.TODOHUKEN;

        this.clearSelectCargo();
        
        this.currPage_order = 1;
        this.currPage_ship = 1;
        this.getOrderCargoList(null, null);
        this.getShipCargoList(null, null);

        this.getCarList();

        this.getBranchList();
        this.getPartnerList();

        this.transSocket = new WebSocket(SERVER.socketURL + '/transport/');
        this.transSocket.addEventListener("message", (event) => {
            var data = JSON.parse(event.data);
            var div: string = data['div'];
            var cargo: Cargo = data['cargo'];
            this.autoRefresh(div, cargo);
        });

        this.userService.getUserCompanyInfo(LOGON_INFO.USER_ID)
        .take(1).subscribe(
            data => {
                this.selectCargoTrans = JSON.stringify(data);
            }
        );
    }



    autoRefresh(div: string, cargo: Cargo) {
        switch (div) {
            //貨物新規登録された場合
            case AppConstants.REGIST:
                //全体公開 または 自社へのみ公開の貨物の場合
                if (this.cargoService.isAccessibleCargo(cargo)) {
                    //リスト先頭に貨物追加
                    if (this.commonService.isBetweenDate(cargo.load_date, this.search_load_date_start, this.search_load_date_end)) {
                        if (this.cargoService.addCargoToList(this.cargoList_order, cargo, this.search_load_todohuken)) {
                            this.msgService.addInfo("貨物運送依頼「ID："+cargo.id+"」が新規登録されました。");
                        }
                    }
                }
                break;
            //貨物情報更新された場合
            case AppConstants.UPDATE:
                //表示中であれば入れ替え
                if (!this.cargoService.replaceCargoFromList(this.cargoList_order, cargo)) {
                    this.cargoService.replaceCargoFromList(this.cargoList_ship, cargo);
                }
                break;
            //貨物受付の場合
            case AppConstants.ACCEPT:
                //上段リストに表示中であれば削除
                this.cargoService.deleteCargoFromList(this.cargoList_order, cargo);

                //自社が受付した場合
                if (cargo.trans_comp_id == LOGON_INFO.COMP_ID) {
                    //下段リスト先頭に貨物追加
                    if (this.commonService.isBetweenDate(cargo.load_date, this.search_ship_load_date_start, this.search_ship_load_date_end)) {
                        if (this.cargoService.addCargoToList(this.cargoList_ship, cargo, this.search_ship_load_todohuken)) {
                            this.totalCount_ship = this.totalCount_ship + 1;
                        }
                    }
                    //ドライバーが受付した場合
                    if (!!cargo.trans_car_id) {
                        this.msgService.addInfo("ドライバーが貨物「ID："+cargo.id+"」を受付しました。");
                    }
                }
                break;
            //受付取消の場合
            case AppConstants.ACCEPT_CANCEL:
                //全体公開 または 自社へのみ公開の貨物の場合
                if (this.cargoService.isAccessibleCargo(cargo)) {
                    //リスト先頭に貨物追加
                    if (this.commonService.isBetweenDate(cargo.load_date, this.search_load_date_start, this.search_load_date_end)) {
                        if (this.cargoService.addCargoToList(this.cargoList_order, cargo, this.search_load_todohuken)) {
                            this.msgService.addInfo("貨物「ID："+cargo.id+"」の受付が取消されました。");
                        }
                    }
                }

                //下段リストに表示中であれば削除
                if (this.cargoService.deleteCargoFromList(this.cargoList_ship, cargo)) {
                    this.totalCount_ship = this.totalCount_ship - 1;
                }
                break;
            //共有情報変更の場合
            case AppConstants.SHARE:
                //全体公開 または 自社へ公開の貨物の場合
                if (this.cargoService.isAccessibleCargo(cargo)) {
                    //表示中であれば入れ替え、表示中でなければリスト先頭に追加
                    if (!this.cargoService.replaceCargoFromList(this.cargoList_order, cargo)) {
                        if (this.commonService.isBetweenDate(cargo.load_date, this.search_load_date_start, this.search_load_date_end)) {
                            this.cargoService.addCargoToList(this.cargoList_order, cargo, this.search_load_todohuken);
                            this.msgService.addInfo("貨物運送依頼「ID："+cargo.id+"」が共有されました。");
                        }
                    }
                }
                //自社へ公開ではない場合
                else {
                    //表示中であれば削除
                    this.cargoService.deleteCargoFromList(this.cargoList_order, cargo);
                }
                break;
            //ドライバーからの運送状況報告の場合
            case AppConstants.REPORT:
                //表示中であれば入れ替え
                if (this.cargoService.replaceCargoFromList(this.cargoList_ship, cargo)) {
                    //車両リスト再取得
                    this.carService.fetchAllCarList()
                    .then( data => {
                        this.mapService.carList = data;
                    })
                    .catch();
                }
                break;
        }
    }


    /*
    deleteCargo(cargoList: Cargo[], cargo: Cargo): boolean {
        let idx = cargoList.findIndex(({id}) => id === cargo.id);
        if (idx > -1) {
            cargoList.splice(idx, 1);
            return true;
        }
        return false;
    }

    spliceCargo(cargoList: Cargo[], cargo: Cargo): boolean {
        let idx = cargoList.findIndex(({id}) => id === cargo.id);
        if (idx > -1) {
            cargoList.splice(idx, 1, cargo);
            return true;
        }
        return false;
    }

    unshiftCargo(cargoList: Cargo[], cargo: Cargo) {
        if (cargoList.length >= this.perPage_order) {
            cargoList.pop();
        }
        cargoList.unshift(cargo);
        cargoList.sort(function(a,b) {
            return b.id - a.id;
        });
    }
*/



    toggleMap() {
        this.isMapShow = !this.isMapShow;
    }


    //所属車両の現在状況情報を取得
    getCarList() {
        //tab1が表示中　かつ　選択中貨物の積み地座標がある場合
        if ($('#tab1').hasClass('active') && (this.currentCargo.load_latitude || this.currentCargo.load_lat)) {
            let load_lat = this.currentCargo.load_latitude ? this.currentCargo.load_latitude : this.currentCargo.load_lat;
            let load_lng = this.currentCargo.load_longitude ? this.currentCargo.load_longitude : this.currentCargo.load_lng;
            this.carService.getRadiusCarList(load_lat, load_lng, 3000)
                .take(1).subscribe(
                    data => {
                        this.carList = data['results'];
                    }
                );
        //上記以外
        } else {
            /*
            this.carService.getAllCarList()
                .take(1).subscribe(
                    data => this.carList = data['results']
                );
            */
            this.carList = this.carService.getAllCarList();
        }
    }


    //支店リストを取得
    getBranchList() {
        if (LOGON_INFO.COMP_TYPE == COMP_TYPE.HEAD || LOGON_INFO.COMP_TYPE == COMP_TYPE.BRANCH) {
            this.companyService.getCompanyList(1, false, true)
            .take(1).subscribe(
                data => {
                    this.branchList = data['results'];
                    this.branchList.splice(this.branchList.findIndex(({comp_id}) => comp_id === this.comp_id), 1);
                    //this.branchList.splice(this.branchList.findIndex(({comp_type}) => comp_type === COMP_TYPE.HEAD), 1);
                }
            );
        }
    }


    //傭車先リストを取得
    getPartnerList() {
        this.companyService.getPartnerList(1, false, true)
        .take(1).subscribe(
            data => {
                this.partnerList = data['results'];
            }
        );
    }



    ////////// 住所選択 START ///////////////////////////////////////////////////

    //住所検索ボタン押下
    searchAddress(div: string) {
        this.search_div = div;
        let searchKeyword = this.f.controls[div+'_search'];
        searchKeyword.setValue(searchKeyword.value.trim().replace(/-/g,''));
        if (searchKeyword.value.length >= 2) {
            this.commonService.searchAddress(searchKeyword.value)
                    .take(1).subscribe(
                        data => {
                            this.address_search_list = data['results'];
                            if (this.address_search_list.length > 1) {
                                $('#addressSearchModal').modal('show');
                            }
                            else if (this.address_search_list.length == 1) {
                                this.setAddress(this.address_search_list[0]);
                            }
                            else {
                                this.msgService.addError("該当する住所が見つかりません。");
                            }
                        }
                    );
        } else {
            this.msgService.addError("２桁以上の文字列を入力してください。");
        }
    }

    //地図から選択
    selectFromMap(div: string) {
        this.search_div = div;
        $('#mapModal').modal('show');
    }

    //履歴から選択
    selectFromHistory(div: string) {
        this.search_div = div;
        this.cargoService.getAddressHistoryList(div)
                .take(1).subscribe(
                    data => {
                        this.address_search_list = data['results'];
                        if (this.address_search_list.length > 0) {
                            $('#addressSearchModal').modal('show');
                        }
                        else {
                            this.msgService.addError("履歴が見つかりません。");
                        }
                    }
                );
    }

    setAddress(locInfo: LocationInfo) {
        if (this.search_div == AppConstants.LOAD) {
            this.currentCargo.load_latitude = locInfo.lat;
            this.currentCargo.load_longitude = locInfo.lng;
            this.currentCargo.load_todohuken = locInfo.todohuken;
            this.currentCargo.load_address = locInfo.address;
        } else {
            this.currentCargo.drop_latitude = locInfo.lat;
            this.currentCargo.drop_longitude = locInfo.lng;
            this.currentCargo.drop_todohuken = locInfo.todohuken;
            this.currentCargo.drop_address = locInfo.address;
        }
    }

    ////////// 住所選択 END ///////////////////////////////////////////////////





    //運送依頼リストの取得（受付前）
    getOrderCargoList(searchStartDate:any, searchEndDate:any) {
        if (!searchStartDate) {
            searchStartDate = this.search_load_date_start;
        }
        if (!searchEndDate) {
            searchEndDate = this.search_load_date_end;
        }

        this.cargoService.getCargoList(CARGO_LIST_TYPE.ORDER, this.currPage_order, '', this.search_load_todohuken, searchStartDate, searchEndDate)
                .take(1).subscribe(
                    data => {
                        this.cargoList_order = data['results'];
                        this.totalCount_order = data['count'];
                    }
                );
    }


    //運送依頼の検索条件をクリア
    clearOrderSearchInfo() {
        this.search_load_todohuken = '';
        this.search_load_date_start = null;
        this.search_load_date_end = null;

        this.cargoService.getCargoList(CARGO_LIST_TYPE.ORDER, this.currPage_order, '', this.search_load_todohuken, null, null)
                .take(1).subscribe(
                    data => {
                        this.cargoList_order = data['results'];
                        this.totalCount_order = data['count'];
                    }
                );
    }


    //運送貨物リストの取得（受付後）
    getShipCargoList(searchStartDate:any, searchEndDate:any) {
        if (!searchStartDate) {
            searchStartDate = this.search_ship_load_date_start;
        }
        if (!searchEndDate) {
            searchEndDate = this.search_ship_load_date_end;
        }

        this.cargoService.getCargoList(CARGO_LIST_TYPE.SHIP, this.currPage_ship,'', this.search_ship_load_todohuken, searchStartDate, searchEndDate)
                .take(1).subscribe(
                    data => {
                        this.cargoList_ship = data['results'];
                        this.totalCount_ship = data['count'];
                    }
                );
    }


    //運送依頼の検索条件をクリア
    clearShipSearchInfo() {
        this.search_ship_load_todohuken = '';
        this.search_ship_load_date_start = null;
        this.search_ship_load_date_end = null;

        this.cargoService.getCargoList(CARGO_LIST_TYPE.SHIP, this.currPage_ship, '', this.search_ship_load_todohuken, null, null)
                .take(1).subscribe(
                    data => {
                        this.cargoList_ship = data['results'];
                        this.totalCount_ship = data['count'];
                    }
                );
    }


    //ページ移動 (paginationからのcallback)
    pageChange_order(page: number) {
        this.currPage_order = page;
        this.getOrderCargoList(this.search_load_date_start, this.search_load_date_end);
    }
    pageChange_ship(page: number) {
        this.currPage_ship = page;
        this.getShipCargoList(this.search_ship_load_date_start, this.search_ship_load_date_end);
    }


    //貨物選択
    onSelect(cargo: Cargo): void {
        //現在選択中の貨物である場合、なにもしない
        if (this.currentCargo.id == cargo.id) {
            return;
        }

        //前回選択貨物情報を保存
        let beforeLoadDate = this.datePipe.transform(this.currentCargo.load_date,'yyyyMMdd');
        let beforeLoadLat = this.currentCargo.load_lat;
        let beforeId = this.currentCargo.id;

        //表示中のマウス右メニューを非表示
        this.hideRightClickMenu();

        //objectをコピー＆初期化
        this.currentCargo = Object.assign({},cargo);
        this.currentCargo.load_drop_date = cargo.load_date + " " + cargo.load_time_name + "時 ▶ " + cargo.drop_date + " " + cargo.drop_time_name + "時";
        // this.currentCargo.cargo_size = cargo.cargo_depth + "cm ✖ " + cargo.cargo_width + "cm ✖ " + cargo.cargo_height + "cm　　" + cargo.cargo_num + "個";

        //地図経路表示用
        this.origin = {lat:+cargo.load_latitude, lng:+cargo.load_longitude};
        this.destination = {lat:+cargo.drop_latitude, lng:+cargo.drop_longitude};

        //配車車両選択領域で「現在状況から選択」TABが表示中の場合
        if ($('#tab1').hasClass('active')) {
            //前回選択貨物と積み地が違う場合
            if (!beforeId || beforeLoadLat != cargo.load_lat) {
                //車両状況リスト再取得
                this.getCarList();
            }
        }
        //配車車両選択領域で「日程表から選択」TABが表示中の場合
        else {
            //前回選択貨物と積み日が違う場合
            if (!beforeId || beforeLoadDate != this.datePipe.transform(cargo.load_date,'yyyyMMdd')) {
                this.startDate = new Date(cargo.load_date);
            }
        }

        this.selectCarid(this.currentCargo.trans_car_id);
    }



    /////// 共有処理関連 //////////////////////////////////////////////
    toggleRightClickSubMenu(e: any, comp_type: string) {
        let targetSubMenu = comp_type == COMP_TYPE.BRANCH ? "#branchSubMenu" : "#partnerSubMenu";
        let untargetSubMenu = comp_type != COMP_TYPE.BRANCH ? "#branchSubMenu" : "#partnerSubMenu";
        $(targetSubMenu).css({
            left: e.pageX,
            top: e.pageY
        });
        $(targetSubMenu).toggle();
        $(untargetSubMenu).hide();
    }

    updateShareInfo(share_flag: string, share_comp_id: string) {
        this.currentCargo.share_flag_2 = share_flag;
        this.currentCargo.share_comp_id_2 = share_comp_id;

        this.cargoService.updateShareInfo(this.currentCargo)
        .take(1).subscribe(
            data => {
                if (share_flag == SHARE_FLAG.COMPANY) {
                    let targetList = this.branchList.concat(this.partnerList);
                    this.currentCargo.share_comp_name = (targetList.find(({comp_id}) => comp_id === share_comp_id)).name;
                } else {
                    this.currentCargo.share_comp_name = null;
                }

                this.currentCargo.update_id = data['update_id'];
                this.currentCargo.update_date = data['update_date'];
                
                this.cargoList_order.splice(this.cargoList_order.findIndex(({id}) => id === this.currentCargo.id), 1, this.currentCargo);

                //send websocket  
                this.transSocket.send(JSON.stringify({
                    'div': AppConstants.SHARE,
                    'cargo_id': this.currentCargo.id
                }));
            }
        );

        this.hideRightClickMenu();
    }
    ////////////////////////////////////////////////////////



    changeImportance(importance: string) {
        this.cargoService.updateCargoImportance(this.currentCargo.id, importance)
        .take(1).subscribe(
            data => {
                this.currentCargo.importance = importance;
                this.cargoList_ship.splice(this.cargoList_ship.findIndex(({id}) => id === this.currentCargo.id), 1, this.currentCargo);
            }
        );
        
        //表示中のマウス右メニューを非表示
        this.hideRightClickMenu();
    }

    
    hideRightClickMenu() {
        $("#branchSubMenu").hide();
        $("#partnerSubMenu").hide();
        $("#rightClickMenu").hide();
    }




    //貨物登録
    async registCargo(status: string) {
        this.currentCargo.status = status;
        if(status == CARGO_STATUS.ACCEPT || status == CARGO_STATUS.MATCH_CAR) {
            this.currentCargo.trans_comp_id = this.comp_id;
            this.currentCargo.trans_car_id = this.selCar.id;
        }

        if(this.commonService.checkStartEndDate(this.currentCargo.load_date, this.currentCargo.load_time, this.currentCargo.drop_date, this.currentCargo.drop_time, false, true, false)) {
            await this.getLatLng();

            await this.cargoService.registCargo(this.currentCargo)
                .take(1).subscribe(
                    data => {
                        this.refreshPage(AppConstants.REGIST, data.id);
                    }
                );
        }
    }


    //住所から地図座標を取得
    async getLatLng() {
        //積み地の地図座標を取得
        await this.mapService.getLatLngFromAddress(this.currentCargo.load_todohuken + this.currentCargo.load_address)
        .then(
            data => {
                this.currentCargo.load_latitude = data.lat();
                this.currentCargo.load_longitude = data.lng();
                //this.msgService.clear();
            }
        )
        .catch(
            error => {
                this.currentCargo.load_latitude = null;
                this.currentCargo.load_longitude = null;
                //this.msgService.add(error);
            }
        );
    
        //卸し地の地図座標を取得
        await this.mapService.getLatLngFromAddress(this.currentCargo.drop_todohuken + this.currentCargo.drop_address)
        .then(
            data => {
                this.currentCargo.drop_latitude = data.lat();
                this.currentCargo.drop_longitude = data.lng();
                //this.msgService.clear();
            }
        ).catch(
            error => {
                this.currentCargo.drop_latitude = null;
                this.currentCargo.drop_longitude = null;
                //this.msgService.add(error);
            }
        );
    }


    //貨物運送依頼の受付
    acceptCargo() {
        this.cargoService.acceptCargo(this.currentCargo.id)
        .take(1).subscribe(
            data => {
                this.refreshPage(AppConstants.ACCEPT, this.currentCargo.id);
            },
            error => {
                if (error.status == "404") {
                    this.getOrderCargoList(null, null);
                    this.getShipCargoList(null, null);
                    this.clearSelectCargo();
                    setTimeout(() => {
                        this.msgService.addError("すでに受付済みの貨物か、荷主から運送依頼が取消、または、他の運送会社が先に受付した貨物です。");
                    }, 1000);
                }
            }
        );
    }

    //貨物受付取消
    cancelAccept() {
        this.cargoService.acceptCancelCargo(this.currentCargo.id)
        .take(1).subscribe(
            data => {
                this.refreshPage(AppConstants.ACCEPT_CANCEL, this.currentCargo.id)
            }
        );
    }


    //貨物登録取消
    cancelCargo() {
        this.cargoService.cancelCargo(this.currentCargo.id)
        .take(1).subscribe(
            data => {
                this.refreshPage(AppConstants.UPDATE, this.currentCargo.id);
            }
        );
    }


    //車両配車
    matchCar() {
        this.cargoService.matchCar(this.currentCargo.id, this.selCar)
        .take(1).subscribe(
            data => {
                let div = this.currentCargo.status==CARGO_STATUS.REGIST? AppConstants.ACCEPT : AppConstants.UPDATE;
                this.refreshPage(div, this.currentCargo.id);
            }
        );
    }

    //車両配車取消
    cancelMatchCar() {
        this.cargoService.matchCarCancel(this.currentCargo.id, this.currentCargo.trans_car_id)
        .take(1).subscribe(
            data => {
                this.refreshPage(AppConstants.UPDATE, this.currentCargo.id);
            }
        );
    }
    

    //配車車両選択（車両状況リスト、googlemapから）
    selectCar(car: Car) {
        this.selCar = car;
    }

    //配車車両選択（スケジュール表から）
    selectCarid(car_id: number) {
        if (car_id) {
            this.selCar = this.carList.find(({id})=>id===car_id);
        }
        else {
            this.selCar = new Car();
        }
    }

    selectCarFromSchedule(car_id: number) {
        this.selectCarid(car_id);
    }



    //画面リフレッシュ
    refreshPage(div: string, cargo_id: number): void {
        //send websocket  
        this.transSocket.send(JSON.stringify({
            'div': div,
            'cargo_id': cargo_id
        }));
        this.clearSelectCargo();
        //this.getOrderCargoList();
        //this.getShipCargoList();
    }


    //入力情報のクリア
    clearSelectCargo(): void {
        //車両リストを初期化
        if (this.currentCargo && this.currentCargo.id) {
            if ($('#tab1').hasClass('active')) {
                this.getCarList();
            }
            else {
                this.startDate = new Date();
            }
        }

        //入力formを初期化
        this.currentCargo = new Cargo();
        this.currentCargo.commission = 0;
        this.currentCargo.cargo_num = 1;
        this.currentCargo.charter_flag = false;
        this.f.resetForm(this.currentCargo);

        //地図表示用objectを初期化
        this.selCar = new Car();
        this.origin = null;
        this.destination = null;

        this.hideRightClickMenu();
    }



    exec() {
        switch ($('#confirmModal_btn').text()) {
            case "登録":
                this.registCargo(CARGO_STATUS.REGIST);
                break;
            case "修正":
                //this.updateCargo();
                break;
            case "取消":
                this.cancelCargo();
                break;
            case "削除":
                //this.deleteCargo();
                break;
            case "複写":
                this.registCargo(CARGO_STATUS.REGIST);
                break;
            case "受付":
                if (this.currentCargo.id) {
                    this.acceptCargo();
                } else {
                    this.registCargo(CARGO_STATUS.ACCEPT);
                }
                break;
            case "配車登録":
                if (this.currentCargo.id) {
                    this.matchCar();
                } else {
                    this.registCargo(CARGO_STATUS.MATCH_CAR);
                }
                break;
        }
    }


    tabSelect(param: number) {
        //車両状況リストTAB選択の場合
        if (param == 1) {
            //車両状況リスト再取得
            //this.getCarList();
        }
        //スケジュールTAB選択の場合
        else {
            //なにもしない
        }
    }



    searchDateChange(type: string, event: any) {
        if (type == "start" && (!this.search_load_date_start || this.search_load_date_start.formatted != event.formatted)) {
            this.getOrderCargoList(event, this.search_load_date_end);
        }
        else if (type == "end" && (!this.search_load_date_end || this.search_load_date_end.formatted != event.formatted)) {
            this.getOrderCargoList(this.search_load_date_start, event);
        }
    }


    searchShipDateChange(type: string, event: any) {
        if (type == "start" && (!this.search_ship_load_date_start || this.search_ship_load_date_start.formatted != event.formatted)) {
            this.getShipCargoList(event, this.search_ship_load_date_end);
        }
        else if (type == "end" && (!this.search_ship_load_date_end || this.search_ship_load_date_end.formatted != event.formatted)) {
            this.getShipCargoList(this.search_ship_load_date_start, event);
        }
    }



    //EXCEL出力
    orderListExportAsExcel() {
        this.commonService.exportAsExcelFile(this.cargoList_order, "貨物運送依頼リスト", false);
    }
    shipListExportAsExcel() {
        this.commonService.exportAsExcelFile(this.cargoList_ship, "配送貨物リスト", false);
    }


    //印刷
    printForm(form_name: string) {
        //印刷用htmlページへ渡すjsonファイルを設定して置く
        this.selectCargo = JSON.stringify(this.currentCargo);

        let client_user_id = form_name=="transfer-request-notification" ? this.currentCargo.update_id : this.currentCargo.create_id;

        this.userService.getUserCompanyInfo(client_user_id)
        .take(1).subscribe(
            data => {
                this.selectCargoClient = JSON.stringify(data);
                window.open(AppConstants.PRINT_FORM_PATH + form_name + '.html');
            },
            error => {
                this.msgService.addError("印刷に失敗しました。");
            }
        );
    }


    ngOnDestroy() {
        this.transSocket.close();
        //this.subscription.unsubscribe();

        //Modalが開いた状態でブラウザの前ページへ移動ボタン押下すると、modalは閉じられるがbackdropが消えない
        //強制的にbackdropを消す
        $(".modal-backdrop").remove();
    }

}


// WEBPACK FOOTER //
// ./src/app/cargo/transport-cargo.component.ts